import { createApp } from 'vue';
import Attach from '../../../_00_elements/tools/attach';
import { replaceElement } from '../../../_00_elements/tools/dom';
import requests from '../../../_00_elements/tools/requests';
import { URL_XHR_PROFILE_PICTURE_EDIT } from '../../../_00_elements/tools/routes/routes';
import TwigFormValidator from '../../../_00_elements/tools/twig-form/validator';
import ProfilePicture from '../../../_01_atoms/components/ProfilePicture.vue';
import Spinner from '../../../_01_atoms/components/Spinner.vue';
import UploadMediaImage from '../../../_01_atoms/components/UploadMediaImage.vue';
import initVuePhoneInput from '../../../_01_atoms/twig-phone-input';

/**
 * User profile edit component
 */
export default function () {
  let phoneInputApp;

  function initFormValidation() {
    const validator = new TwigFormValidator({
      formSelector: '#app_user_profile_edit_form',
      rules: {
        'app_user_profile[firstname]': [ 'required', 'noNumbers' ],
        'app_user_profile[lastname]': [ 'required', 'noNumbers' ],
        'app_user_profile[email]': [ 'required', 'email' ],
        'app_user_profile[phoneNumber]': 'phone',
      },
      onFailure: (event, messages) => {
        const phoneError = messages['app_user_profile[phoneNumber]'];
        phoneInputApp.error = phoneError ?? null;
      },
      onSuccess: (event) => {
        phoneInputApp.error = null;
        Attach.asyncSubmit(event).then((result) => {
          if (result.data.reload) {
            window.location.reload();
          } else {
            replaceElement('#user-profile-edit-block .container', result.data, '.container');
            processProfileForm(); // eslint-disable-line no-use-before-define
          }
        });
      },
    });
    validator.init();
  }

  function processProfileForm() {
    phoneInputApp = initVuePhoneInput('vue-phone-input');
    initFormValidation();
  }

  if (document.getElementById('app_user_profile_edit_form')) {
    processProfileForm();
  }

  const pictureSelector = '.user-profile-edit__upload-profile-picture';
  if (document.querySelector(pictureSelector)) {
    const uploadPictureComponent = {
      components: { UploadMediaImage, ProfilePicture, Spinner },
      props: {
        initUuid: { type: String, default: null },
      },
      data() {
        return {
          uuid: this.initUuid,
          loading: false,
        };
      },
      watch: {
        async uuid(newUuid) {
          if (newUuid !== this.initUuid) {
            await requests.post(
              URL_XHR_PROFILE_PICTURE_EDIT,
              { uuid: newUuid },
            );
          }
        },
      },
    };
    createApp(uploadPictureComponent, { ...document.querySelector(pictureSelector).dataset }).mount(pictureSelector);
  }
}
